(() => {
  function revealSelected(input) {
    const item = input.closest('.swatch-item');
    const list = item?.closest('.product-card__swatch-list');
    if (!item?.offsetWidth || !list) return;
    if (item.offsetLeft < list.scrollLeft) list.scrollLeft = item.offsetLeft;
    else if (item.offsetLeft + item.offsetWidth > list.scrollLeft + list.clientWidth) {
      list.scrollLeft = item.offsetLeft + item.offsetWidth - list.clientWidth;
    }
  }

  function init(section) {
    if (section.dataset.stickersInitialized) return;
    section.dataset.stickersInitialized = 'true';
    const root = section.closest('[data-thankful20]') || section;
    const isCanada = root.dataset.country === 'CA';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency', currency: root.dataset.currency || 'CAD', currencyDisplay: 'code'
    });

    function update(card) {
      const variant = card.querySelector('[data-sticker-variant]:checked');
      const variantId = variant?.value || card.dataset.variantId;
      const unitPrice = Number(variant?.dataset.t20UnitPrice ?? card.dataset.unitPrice);
      const salePrice = Number(variant?.dataset.t20SalePrice ?? card.dataset.salePrice);
      const url = new URL(card.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variantId);
      card.querySelectorAll('[data-sticker-product-link], [data-sticker-product-link-wrap] a').forEach(link => { link.href = url.href; });
      const quickAdd = card.querySelector('[data-sticker-quick-add-variant]');
      if (quickAdd) quickAdd.value = variantId;

      if (variant) {
        const img = card.querySelector('[data-sticker-image]');
        if (img && variant.dataset.image && img.getAttribute('src') !== variant.dataset.image) {
          img.removeAttribute('srcset');
          img.src = variant.dataset.image;
          img.alt = variant.dataset.alt || variant.dataset.variantTitle;
        }
        const colour = card.querySelector('[data-sticker-selected-colour]');
        if (colour) colour.textContent = variant.dataset.colour;
        revealSelected(variant);
      }

      const current = card.querySelector('[data-sticker-current-price]');
      if (current) current.textContent = money.format((isCanada ? salePrice : unitPrice) / 100);
      const regular = card.querySelector('[data-sticker-regular-price]');
      if (regular) regular.textContent = money.format(unitPrice / 100);
    }

    const cards = [...section.querySelectorAll('[data-sticker-card]')];
    cards.forEach(card => {
      card.addEventListener('change', event => {
        if (event.target.matches('[data-sticker-variant]') && event.target.checked) update(card);
      });
      update(card);
    });
    const count = section.querySelector('[data-sticker-count]');
    const filters = section.querySelector('[data-sticker-filters]');
    const filterButtons = [...(filters?.querySelectorAll('[data-sticker-filter]') || [])];
    function filter(category) {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = Boolean(category && card.dataset.stickerCategory !== category);
        if (!card.hidden) visible++;
      });
      if (count) count.textContent = `${visible} design${visible === 1 ? '' : 's'}`;
      filterButtons.forEach(button => {
        button.setAttribute('aria-pressed', String((button.dataset.stickerFilter || '') === category));
      });
    }
    filterButtons.forEach(button => button.addEventListener('click', () => filter(button.dataset.stickerFilter || '')));
    if (filters) filters.hidden = false;
    filter(filterButtons.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.stickerFilter || '');
    // Native custom.js owns .show-more-button expansion for the shared swatch classes.
  }

  document.querySelectorAll('[data-sticker-section]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-sticker-section]')) init(event.target);
    event.target.querySelectorAll('[data-sticker-section]').forEach(init);
  });
})();
